import { parseFormattedNumber } from "../components/FormDialog/utils";

export function parseGross(value) {
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const parsed = parseFormattedNumber(value);
    return !isNaN(parsed) ? parsed : parseFloat(value) || 0;
  }
  return 0;
}

export function validateBankSelected(receipt, bankId) {
  if (!bankId) {
    return { receipt, reason: "No bank selected" };
  }
  return null;
}

export function validateBankExists(receipt, bankObj) {
  if (!bankObj) {
    return { receipt, reason: "Bank not found" };
  }
  return null;
}

export function validateGrossAmount(receipt, grossAmount) {
  if (grossAmount <= 0) {
    return { receipt, reason: "Invalid gross amount" };
  }
  return null;
}

export function validateBankBalance(receipt, bankObj, grossAmount) {
  const balance = parseFloat(bankObj?.balance) || 0;
  if (balance < grossAmount) {
    return {
      receipt,
      reason: `Insufficient balance (₱${balance.toFixed(2)} < ₱${grossAmount.toFixed(2)})`,
    };
  }
  return null;
}

export function validateReceiptForSubmission(
  receipt,
  bankId,
  bankObj,
  grossAmount,
  options = { checkBankExists: true },
) {
  const bankSelectedError = validateBankSelected(receipt, bankId);
  if (bankSelectedError) return bankSelectedError;

  if (options.checkBankExists) {
    const bankExistsError = validateBankExists(receipt, bankObj);
    if (bankExistsError) return bankExistsError;
  }

  const grossAmountError = validateGrossAmount(receipt, grossAmount);
  if (grossAmountError) return grossAmountError;

  const balanceError = validateBankBalance(receipt, bankObj, grossAmount);
  if (balanceError) return balanceError;

  return null;
}
